<template>
	<div class="l-edit-dialog-box">
		<el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left">
			<el-form-item label="登录名/名称" prop="userName">
				<el-input v-model="form_data.userName" autocomplete="off" placeholder="请输入新密码"></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="pwd">
				<el-input type="password" v-model="form_data.pwd" autocomplete="off" placeholder="请输入新密码"></el-input>
			</el-form-item>
			<el-form-item label="新密码确认" prop="re_pwd">
				<el-input type="password" v-model="form_data.re_pwd" autocomplete="off" placeholder="请再次输入新密码"></el-input>
			</el-form-item>
		</el-form>
		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: "user-change-pwd",
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},

	data() {
		return {
			//表单数据
			form_data: {
				id: "",
				pwd: "",
				re_pwd: "",
				userName:""
			},
			//表单验证规则
			rules: {
				// pwd: [{ required: true, message: "密码不能为空", trigger: "change" }],
				// re_pwd: [{ required: true, message: "密码确认不能为空", trigger: "change" }],
			},
			submitting: false,
		};
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//提交数据
		handleSubmit() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					this.form_data.id = this.$props.id;
					this.$_invoke('user_changePwd', this.form_data)
						.then(() => {
							this.$_msg.success("修改成功");
							this.$emit("on-success");
						})
						.finally(() => {
							this.submitting = false;
						});
				}
			});
		},
	},
};
</script>
